// import styled, { css } from 'styled-components'
import { Number } from '../../../styles/defaults'

export const IconNumber = Number.extend`
  position: relative;
`


// WEBPACK FOOTER //
// ./src/components/MobileHeader/PageMenuDropdown/styles.js